export default "__VITE_ASSET__B_n0tKnf__"